import { GramPostProps } from "../../../Components/TheGramApp/TheGramAppInterfaces";

import pic1 from "./WhiteHouseTheGramAssets/Post-1.webp";
import pic2 from "./WhiteHouseTheGramAssets/Post-2.webp";
import dp1 from "./WhiteHouseTheGramAssets/George-Profile.webp";

import comentpic1 from "./WhiteHouseTheGramAssets/Commener-1.webp";
import comentpic2 from "./WhiteHouseTheGramAssets/Commener-2.webp";
import comentpic3 from "./WhiteHouseTheGramAssets/Commener-3.webp";

export const WhiteHouseTheGramContent: GramPostProps[] = [
  {
    Profile: { name: "@GeorgeMcFarlane", image: dp1 },
    Date: "27 Nov 2022",
    Image: pic1,
    Likes: "49,320",
    Caption:
      "No matter what the reports say, @elizabethmcfarlane and I are strong as ever.",
    Location: "",
    Comments: [
      {
        ProfilePic: comentpic1,
        Commenter: "@johanna_blawk",
        Comment:
          "they don't deserve the hate they get. Difficult time to come into office and they're trying their best",
      },
      {
        ProfilePic: comentpic2,
        Commenter: "@robmcf_",
        Comment: "worst US president ever.",
      },
      {
        ProfilePic: comentpic3,
        Commenter: "@joesavj",
        Comment: "🔥🔥🔥🔥",
      },
    ],
  },
  {
    Profile: { name: "@GeorgeMcFarlane", image: dp1 },
    Date: "14 May 2022",
    Image: pic2,
    Likes: "62,748",
    Caption: "Our dog, Buster, turns 12 today. Always by my side 💙",
    Location: "",
  },

  // Add more dummy data objects as needed
];
